import { lazy } from "react";

const create = lazy(() => import("./Create").then(m => ({ default: m.InvestmentAxysCodeCreate })));

export default { create };
